(() => {
  'use strict';
  function init(root = document) {
    const sections = [...root.querySelectorAll('[data-pawlume-product]')];
    if (root.matches?.('[data-pawlume-product]')) sections.unshift(root);
    sections.forEach((section) => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const image = section.querySelector('.plp-image');
      const thumbs = [...section.querySelectorAll('[data-gallery-src]')];
      const form = section.querySelector('form');
      const button = section.querySelector('[data-add-button]');
      const price = section.querySelector('[data-product-price]');
      function setImage(src, alt) {
        if (!src || !image) return;
        image.removeAttribute('srcset'); image.removeAttribute('sizes');
        image.src = src; image.alt = alt || 'Pet projector product photograph';
        thumbs.forEach((t) => t.setAttribute('aria-pressed', String(t.dataset.gallerySrc === src)));
      }
      thumbs.forEach((t) => t.addEventListener('click', () => setImage(t.dataset.gallerySrc, t.dataset.galleryAlt)));
      function syncVariant(changePhoto = false) {
        const radio = section.querySelector('input[name="id"]:checked');
        if (!radio || !button) return;
        const available = radio.dataset.variantAvailable === 'true';
        if (price && radio.dataset.variantPrice) price.textContent = radio.dataset.variantPrice;
        button.disabled = !available;
        button.removeAttribute('aria-busy');
        button.querySelector('span').textContent = available ? button.dataset.idleText : 'Currently unavailable';
        if (changePhoto) setImage(radio.dataset.variantPhoto, radio.dataset.variantAlt);
      }
      section.querySelectorAll('input[name="id"]').forEach((radio) => radio.addEventListener('change', () => syncVariant(true)));
      syncVariant();
      window.addEventListener('pageshow', () => { if (section.isConnected) syncVariant(); });
      const input = section.querySelector('input[type="file"]');
      const preview = section.querySelector('[data-upload-preview]');
      const label = section.querySelector('[data-upload-label]');
      const error = section.querySelector('[data-file-error]');
      let previewURL;
      if (input && preview && label && error) input.addEventListener('change', () => {
        if (previewURL) URL.revokeObjectURL(previewURL);
        preview.hidden = true; preview.removeAttribute('src'); error.hidden = true;
        input.setCustomValidity(''); label.textContent = 'Choose a pet photo';
        const file = input.files?.[0];
        if (!file) return;
        const allowed = ['image/jpeg', 'image/png', 'image/webp'];
        const problem = !allowed.includes(file.type) ? 'Please choose a JPG, PNG or WEBP photo.' : file.size > 10 * 1024 * 1024 ? 'Please choose a photo no larger than 10 MB.' : '';
        if (problem) { error.textContent = problem; error.hidden = false; input.value = ''; input.setCustomValidity(problem); input.reportValidity(); return; }
        previewURL = URL.createObjectURL(file); preview.src = previewURL; preview.hidden = false;
        label.textContent = 'Photo added — tap to change';
      });
      if (form && button) form.addEventListener('submit', (event) => {
        if (button.disabled || !form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
        button.querySelector('span').textContent = button.dataset.loadingText;
        button.setAttribute('aria-busy', 'true');
      });
    });
    root.querySelectorAll('.mobile-menu').forEach((menu) => {
      if (menu.dataset.menuReady) return;
      menu.dataset.menuReady = 'true';
      menu.querySelectorAll('nav a').forEach((link) => link.addEventListener('click', () => { menu.open = false; }));
      menu.addEventListener('keydown', (event) => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary')?.focus(); } });
    });
  }
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
